/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-04-17 17:40:52
 * @LastEditors: changfeng
 * @LastEditTime: 2024-05-07 20:59:10
 */
import { message } from "antd";

/**
 * @description: 校验网络请求状态码
 * @param {Number} status
 * @return void
 */
export const checkStatus = (status: number): void => {
	// console.log("statusstatusstatusstatus", status);
	switch (status) {
		case 400:
			message.error("Request error!");
			break;
		case 401:
			message.error("Unauthorized!");
			break;
		case 403:
			message.error("Forbidden!");
			break;
		case 404:
			message.error("Request not found!");
			break;
		case 405:
			message.error("Request method not allowed! ");
			break;
		case 408:
			message.error("Request timeout!");
			break;
		case 500:
			message.error("Server error!");
			break;
		case 502:
			message.error("Bad gateway!");
			break;
		case 503:
			message.error("Service unavailable!");
			break;
		case 504:
			message.error("Gateway timeout!");
			break;
		default:
			message.error("Unknown error!");
	}
};
